export default __webpack_public_path__ + "static/media/email.6973da4f.svg";